import React from 'react';
import { Link } from 'react-router-dom';
import { Footer } from '../Common/Footer';
import { SideBar } from '../Common/SideBar';
import { DashboardHeader } from '../Common/DashboardHeader';
import Products from '../../Models/Products';
import Profile from '../../Models/Profile';
import axios from 'axios';
import SimpleReactValidator from 'simple-react-validator';
import { Header } from '../Common';
class Portfolio extends React.Component {
    constructor(props) {
        super(props);
        let x = JSON.parse(localStorage.getItem('info'))
        if (x === null || x === '' || x.user_type_id !== 2) {
            alert('ログインしてください')
            window.location.href = '/login/seller';
        };
        var retrievedObject = window.localStorage.getItem('info');
        var logged_user = JSON.parse(retrievedObject);
        // console.log(logged_user) 
        this.state = {
            _id: false,
            productsList: [],
            user: logged_user,
            category: [],
            file: null,
            cat: '',
            title: '',
            details: '',
            date: '',
            username: logged_user.id
        };
        this.validator = new SimpleReactValidator({ autoForceUpdate: this });
    }
    onChange(e) {
        this.setState({ file: e.target.files[0] })
    }
    updateValue(type, e) {
        var obj = {};
        obj[type] = e.target.type === "checkbox" ? e.target.checked : e.target.value;
        this.setState(obj);
    }
    componentDidMount() {
        Profile.getPortfolioCat().then(res => {
            if (res.data.categories != null) {
                this.setState({ category: res.data.categories })
            }
        })
    }
    handleSubmit(e) {
        if (this.state.file == null) {
            alert("Please upload image");
        } else if (this.state.title == '') {
            alert("Please insert title");
        } else if (this.state.details == '') {
            alert("Please insert details about your work");
        } else {
            e.preventDefault();
            this.state.cat = 258;

            const formData = new FormData();
            formData.append('username', this.state.username)
            formData.append('file', this.state.file)
            formData.append('category', this.state.cat)
            formData.append('title', this.state.title)
            formData.append('details', this.state.details)
            formData.append('date', this.state.date)
            axios({
                method: 'post',
                // url: 'http://127.0.0.1/sharework_back_v2/public/backend/upload-portfolio-item',
                url: 'https://share-work.jp/backend/upload-portfolio-item',
                data: formData,
                config: {
                    headers: {
                        'content-type': 'multipart/form-data'
                    }
                }
            }).then(
                window.location.href = '/seller-edit-profile'
                )
                .catch(
                    console.log('Could not redirect!')
                )
        }
    }

    button() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div style={{ textAlign: "center", padding: "5%" }}>
                    <div className="col-md-6">
                        <button onClick={this.handleSubmit.bind(this)} style={{ padding: "1%", borderRadius: "4px", backgroundColor: "#8fb95f", color: "white", width: "100%", border: "1px solid" }}>送信する</button>
                    </div>
                    <div>&nbsp;</div>
                    <div className="col-md-6">
                        <Link style={{ color: "#777272" }} to={{
                            pathname: `/seller-edit-profile`,
                        }}>
                            <button style={{ padding: "1%", borderRadius: "4px", backgroundColor: "white", color: "green", width: "100%", border: "1px solid" }}>キャンセル</button>
                        </Link>
                    </div>
                </div>
            )
        } else if (isDesktop) {
            return (
                <div style={{ textAlign: "center", padding: "5%" }}>
                    <button onClick={this.handleSubmit.bind(this)} style={{ padding: "1%", borderRadius: "4px", backgroundColor: "#8fb95f", color: "white", width: "20%", border: "1px solid" }}>送信する</button>
                    <div>&nbsp;</div>
                    <Link style={{ color: "#777272" }} to={{
                        pathname: `/seller-edit-profile`,
                    }}>
                        <button style={{ padding: "1%", borderRadius: "4px", backgroundColor: "white", color: "green", width: "20%", border: "1px solid" }}>キャンセル</button>
                    </Link>
                </div>
            )
        }
    }

    render() {
        const isMobile = window.innerWidth <= 500;
        const isDesktop = window.innerWidth >= 500;
        if (isMobile) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5"></div>
                    <div className="container-fluid">
                        <div className="row">
                            <div className="col-md-8" style={{ minHeight: "500px", backgroundColor: "#f1f1f1" }}>
                                <div className="mb-3 input_name big_font guide_text" style={{ width: "100%" }}>
                                    ユーザー情報
                                    </div>
                                <div style={{ width: "100%", minHeight: "100px", backgroundColor: "white", padding: "2%" }}>
                                    <div>ポートフォリオ画像をアップロードしてください</div>
                                    <br />
                                    <div><input type="file" onChange={this.onChange.bind(this)}></input></div>
                                </div>
                                <div style={{display: "none"}}>カテゴリー</div>
                                <div style={{display: "none"}}>
                                    <select className="cat_drop" ref="Category" style={{ height: "40px", padding: "1%" }}>
                                        <option>選択してください </option>
                                        {this.state.category.map(rp =>
                                            <option value={rp.id} key={rp.id} >
                                                {rp.cat_name}
                                            </option>
                                        )}
                                    </select>
                                </div>
                                <div>&nbsp;</div>
                                <div>タイトル</div>
                                <div><input onChange={this.updateValue.bind(this, 'title')} style={{ width: "100%", border: "1px solid #d6d6d6", borderRadius: "3px", height: "35px", padding: "2%" }}></input></div>
                                <div>&nbsp;</div>
                                <div>内容</div>
                                <div><textarea onChange={this.updateValue.bind(this, 'details')} style={{ width: "100%", border: "1px solid #d6d6d6", borderRadius: "3px", height: "135px", padding: "2%" }}></textarea></div>
                                <div>&nbsp;</div>
                                <div>作成日</div>
                                <div><input onChange={this.updateValue.bind(this, 'date')} style={{ border: "1px solid #d6d6d6", borderRadius: "3px", height: "35px", padding: "1%" }} type="date"></input></div>
                                {this.button()}
                                {/* <div style={{ textAlign: "center", padding: "5%" }}>
                                        <button onClick={this.handleSubmit.bind(this)} style={{ padding: "1%", borderRadius: "4px", backgroundColor: "#8fb95f", color: "white", width: "20%", border: "1px solid" }}>送信する</button>
                                        <div>&nbsp;</div>
                                        <Link style={{ color: "#777272" }} to={{
                                            pathname: `/seller-edit-profile`,
                                        }}>
                                            <button style={{ padding: "1%", borderRadius: "4px", backgroundColor: "white", color: "green", width: "20%", border: "1px solid" }}>キャンセル</button>
                                        </Link>
                                    </div> */}
                            </div>
                        </div>
                    </div >
                <Footer />
                </div >
            )
        } else if (isDesktop) {
            return (
                <div>
                    <Header />
                    <div className="col-md-12 tr_blank_medium mt-5 pt-4"></div>
                    <div className="col-md-12 tr_blank_medium mt-5 "></div>
                    <div className="container-fluid">
                        <div className="container">
                            <div className="col-md-12">
                                <div className="row">
                                    <div className="col-md-4 input_name ">
                                        <SideBar />
                                    </div>
                                    <div className="col-md-8" style={{ minHeight: "500px", backgroundColor: "#f1f1f1" }}>
                                        <div className="mb-3 input_name big_font guide_text" style={{ width: "100%" }}>
                                            ユーザー情報
                                    </div>
                                        <div style={{ width: "100%", height: "100px", backgroundColor: "white", padding: "2%" }}>
                                            <div>ポートフォリオ画像をアップロードしてください</div>
                                            <br />
                                            <div><input type="file" onChange={this.onChange.bind(this)}></input></div>
                                        </div>
                                        <div style={{display: "none"}}>カテゴリー</div>
                                        <div style={{display: "none"}}>
                                            <select className="cat_drop" ref="Category" style={{ height: "40px", padding: "1%" }}>
                                                <option>選択してください </option>
                                                {this.state.category.map(rp =>
                                                    <option value={rp.id} key={rp.id} >
                                                        {rp.cat_name}
                                                    </option>
                                                )}
                                            </select>
                                        </div>
                                        <div>&nbsp;</div>
                                        <div>タイトル</div>
                                        <div><input onChange={this.updateValue.bind(this, 'title')} style={{ width: "100%", border: "1px solid #d6d6d6", borderRadius: "3px", height: "35px", padding: "2%" }}></input></div>
                                        <div>&nbsp;</div>
                                        <div>内容</div>
                                        <div><textarea onChange={this.updateValue.bind(this, 'details')} style={{ width: "100%", border: "1px solid #d6d6d6", borderRadius: "3px", height: "135px", padding: "2%" }}></textarea></div>
                                        <div>&nbsp;</div>
                                        <div>作成日</div>
                                        <div><input onChange={this.updateValue.bind(this, 'date')} style={{ border: "1px solid #d6d6d6", borderRadius: "3px", height: "35px", padding: "1%" }} type="date"></input></div>
                                        {this.button()}
                                        {/* <div style={{ textAlign: "center", padding: "5%" }}>
                                        <button onClick={this.handleSubmit.bind(this)} style={{ padding: "1%", borderRadius: "4px", backgroundColor: "#8fb95f", color: "white", width: "20%", border: "1px solid" }}>送信する</button>
                                        <div>&nbsp;</div>
                                        <Link style={{ color: "#777272" }} to={{
                                            pathname: `/seller-edit-profile`,
                                        }}>
                                            <button style={{ padding: "1%", borderRadius: "4px", backgroundColor: "white", color: "green", width: "20%", border: "1px solid" }}>キャンセル</button>
                                        </Link>
                                    </div> */}
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>
                    <Footer />
                </div>
            )
        }
    }
}
export { Portfolio }